mtl.alloy.factory['load-sku'] = (function($) {
	'use strict';

	return function(element, options) {

		var $element = $(element);

		$("[data-type='variants']", $element).on('change', function(){
			var sku = $("option:selected", this).data("sku");

			var $modalContent = $element.parents('.fancybox-inner');
			var $modalUrl = window.location.pathname;
			
			if($modalContent.length)
				$modalUrl = $("link[rel='canonical']", $modalContent).attr('href');

			if(typeof sku != 'undefined')
			{
				var $queryString = '?sku='+encodeURIComponent(sku);

				if (history.pushState && $modalContent.length == 0) {
				    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + $queryString;
				    window.history.pushState({path:newurl},'',newurl);
				}

				$.ajax({
		            url: $modalUrl + $queryString,
		            cache: false,
		            success: function(jsonContent){
		                $('.price meta[itemprop=price]', $element).attr('content', ((jsonContent.price > 0) ? jsonContent.price/100 : jsonContent.price));
		                $('.price strong', $element).text(currencyFormat((jsonContent.price > 0) ? jsonContent.price/100 : jsonContent.price));
		                $('.sku .code', $element).text(jsonContent.sku);
		                $('.stock', $element).html(jsonContent.deliveryLeadtimeHtml);
		                $('.wishlist', $element).replaceWith(jsonContent.wishlistHtml);
		                mtl.alloy.process($('.wishlist', $element));

		                $('.previousPrice', $element).text(currencyFormat((jsonContent.previousPrice > 0) ? jsonContent.previousPrice/100 : jsonContent.previousPrice));
		                $('.savingPrice', $element).text(currencyFormat((jsonContent.saving > 0) ? jsonContent.saving/100 : jsonContent.saving));
		                $('.cycle-pager a:eq('+($('#mainImage.cycle-slideshow a:not(.cycle-sentinel) img[title="'+jsonContent.sku+'"]').parent().index() - 1)+')').click();
		            },
		        });
			}
		});

		$("[data-type='variants']", $element).each(function(){
			var availableOptions = $("option[value!='']", this).length;

			if(availableOptions <= 1)
			{
				$(this).parent().hide();
				$("option[value!='']", this).prop('selected', 'selected');
			} else {
				$(this).parent().show();
			}
		});

	};

}($));
